export default __webpack_public_path__ + "static/suprime-bg-d76ffd4fec52d0a764b36a2b265069f5.webp";